import { render, staticRenderFns } from "./uplevel-level-num-stat.vue?vue&type=template&id=13a7ee72&scoped=true&"
import script from "./uplevel-level-num-stat.vue?vue&type=script&lang=js&"
export * from "./uplevel-level-num-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7ee72",
  null
  
)

export default component.exports